export const API_VERSION_PATH_PREFIX = '/v1';
export const buildApiUrl = (path: string): string => {
    return `/api${API_VERSION_PATH_PREFIX}${path}`;
};
